import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import {
  Flex,
  Heading,
  Box,
  Button,
  HStack,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Input,
  IconButton,
} from '@chakra-ui/react'
import { AiOutlineClose, AiOutlineSearch } from 'react-icons/ai';

import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import TabelaOutrasPaginas from './tabela-pagina';
import * as api from '../../../api/outrasPaginas';
import Paginacao from '../../../components/common/paginacao/paginacao';

const GerenciarPaginas = () => {
  const [paginas, setPaginas] = useState<any[]>([]);
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState<boolean>(false);
  const [pesquisa, setPesquisa] = useState<string>('');
  const navigate = useNavigate()

  useEffect(() => {
    const fetchPaginas = async () => {
      setLoading(true);
      try {
        const data = await api.listarPagina(
          paginaAtual,
          itemsPerPage,
          pesquisa || undefined,
        );

        setPaginas(data.formatoArquivos.map((pagina: any) => ({
          seqPagina: pagina.seqPagina,
          datRegistro: pagina.datRegistro,
          nomPagina: pagina.nomPagina,
          dscUrl: pagina.dscUrl,
          codModeloPagina: pagina.codModeloPagina
        })));
        setTotalPages(data.totalPaginas);

      } catch (error) {
        console.error('Erro ao buscar outras páginas:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaginas();
  }, [paginaAtual, itemsPerPage, pesquisa]);

  useEffect(() => {
    setPaginaAtual(1);
  }, [pesquisa]);

  return (
    <Flex p="40px" bgColor="#fafafa" direction="column" w="100%">
      <SettingsBreadcrumb />
      <Heading
        mt="30px"
        fontWeight="600"
        fontSize="21px"
        color="#6F6F6F"
        w="100%"
      >
        Gerenciar Outras Páginas
      </Heading>

      <Flex
        w="100%"
        mt="40px"
        mb="20px"
        align="flex-start"
        justify="space-between"
        flexWrap="wrap"
        gap="16px"
      >
        <Button
          color="#fff"
          bgColor="#1789FC"
          _hover={{
            bgColor: "#1468C9"
          }}
          onClick={() => navigate('inserir-pagina')}
        >
          Inserir Página
        </Button>

        <Box flex="1" minW="280px">
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <AiOutlineSearch color="#6e6e6e" />
            </InputLeftElement>
            <Input
              bg="white"
              placeholder="Pesquisar por título..."
              value={pesquisa}
              onChange={e => setPesquisa(e.target.value)}
            />
            {pesquisa && (
              <InputRightElement>
                <IconButton
                  size="sm"
                  variant="ghost"
                  aria-label="Limpar busca"
                  icon={<AiOutlineClose />}
                  onClick={() => setPesquisa('')}
                />
              </InputRightElement>
            )}
          </InputGroup>
        </Box>
      </Flex>

      <Box>
        <TabelaOutrasPaginas 
          listaOutrasPaginas={paginas} 
          listaVazia="Nenhum dado disponível." 
          loading={loading}
        />
      </Box>

      <Paginacao 
        paginaAtual={paginaAtual} 
        totalPages={totalPages} 
        onPageChange={setPaginaAtual}
      />
    </Flex>
  )
}

export default GerenciarPaginas
